import { OnboardingRootState } from "../reducers/rootReducer";
import {
  GameConceptPageState,
  initialGameConceptPageState,
} from "../reducers/gameConceptPageReducer";
import { getOnboardingState } from "./rootSelectors";

export const getGameConceptPageState = (state: OnboardingRootState): GameConceptPageState =>
  getOnboardingState(state)?.gameConceptPage ?? initialGameConceptPageState;

export const getGameConceptPageData = (state: OnboardingRootState) =>
  getGameConceptPageState(state).data;

export const getGameConceptPageIsLoading = (state: OnboardingRootState) =>
  getGameConceptPageState(state).isLoading;

export const getGameConceptPageIsSaving = (state: OnboardingRootState) =>
  getGameConceptPageState(state).isSaving;

export const getGameConceptPageIsSubmitting = (state: OnboardingRootState) =>
  getGameConceptPageState(state).isSubmitting;

export const getGameConceptPageError = (state: OnboardingRootState) =>
  getGameConceptPageState(state).error;

export const getGameConceptPageAccountType = (state: OnboardingRootState) =>
  getGameConceptPageState(state).data?.accountType;

export const getGameConceptPageIsDraft = (state: OnboardingRootState) =>
  getGameConceptPageState(state).data?.isDraft ?? true;
